import { logger } from '@teko/log';
import {
  FCM_REGISTER_TOKEN_SUCCESS,
  FCM_TOKEN,
  FCM_TRANSPORT,
  FCM_USER_ID,
  NotificationService,
} from '@teko/notification';
import { Profile } from '@teko/user';
import { getMessaging, getToken } from 'firebase/messaging';

export const getFcmToken = async (vapidKey: string): Promise<string> => {
  // step 1 delete pushdy service worker
  try {
    const registrations = await navigator.serviceWorker.getRegistrations();
    const pushdyUrl = location.protocol + '//' + location.host + '/sw.js';
    registrations.forEach((reg) => {
      if (reg?.active?.scriptURL === pushdyUrl) {
        reg.unregister();
      }
    });
  } catch (e) {
    logger.error(e);
  }
  // step 2 register firebase cloud messaging
  const messaging = getMessaging();
  const token = await getToken(messaging, {
    vapidKey,
  });
  return token;
};

export const registerFcmToken = async (
  fcmToken: string,
  user: Profile,
  notificationAppId: string,
  notificationService: NotificationService,
): Promise<void> => {
  const lsToken = localStorage.getItem(FCM_TOKEN);
  const lsUserId = localStorage.getItem(FCM_USER_ID);
  const lsRegisterTokenSuccess = localStorage.getItem(
    FCM_REGISTER_TOKEN_SUCCESS,
  );
  const registerCondition =
    // when firebase updates token, when first time users using the app
    fcmToken !== lsToken ||
    // When the user logs in
    (user?.userId && user.userId !== lsUserId) ||
    // When registration failed last time
    lsRegisterTokenSuccess === 'false';

  if (registerCondition) {
    try {
      await notificationService.registerToken({
        app_id: notificationAppId,
        user_id: user?.userId ?? undefined,
        transport: FCM_TRANSPORT,
        token: fcmToken,
        email: user?.email ?? undefined,
        phone: user?.telephone ?? undefined,
      });
      localStorage.setItem(FCM_REGISTER_TOKEN_SUCCESS, 'true');
      if (user?.userId) {
        localStorage.setItem(FCM_USER_ID, user.userId);
      }
    } catch (e) {
      localStorage.setItem(FCM_REGISTER_TOKEN_SUCCESS, 'false');
    }
  }
  localStorage.setItem(FCM_TOKEN, fcmToken);
};

export const unregisterFcmToken = async (
  notificationService: NotificationService,
  notificationAppId: string,
): Promise<void> => {
  try {
    const lsToken = localStorage.getItem(FCM_TOKEN);
    const lsUserId = localStorage.getItem(FCM_USER_ID);
    await notificationService.unRegisterToken({
      user_id: lsUserId,
      app_id: notificationAppId,
      transport: FCM_TRANSPORT,
      token: lsToken,
    });
  } finally {
    localStorage.removeItem(FCM_USER_ID);
  }
};
